import React, { Component } from 'react';
import ImageUploader from './../../../../commons/ImageUploader.js';
import InwardingApiHandlerTest from './../../InwardingApiHandlerTest.js';
import InputFloating from './../../../../commons/InputFloating.js';
import Radio from '@material-ui/core/Radio';
import { CircularProgress } from '@material-ui/core';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
import MobLoader from '../../../../commons/MobLoader';
import ErrorBox from '../../../../commons/ErrorBox';

// const numfor = new Intl.NumberFormat('en-IN', {
//     style: 'currency',
//     currency: 'INR',
//     minimumFractionDigits: 0
// });

const offerTypes = ['Within Pack/Kitted', 'Outside Pack/Unkitted'];

const offerDescriptions1 = [
    'Rs. Off (Rs.X OFF)',
    'Extra Grammage % (X% Extra)',
    'Extra Grammage (Xg FREE)',
    'Different product free inside (FREE X product worth Y Rs)',
];

const offerDescriptions2 = [
    'Same Product Free (Buy X get Y FREE)',
    'Different Product Free',
];

export default class CreateNewListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading1: false,
            newMrp: '',
            listingHasOffer: false,
            selectedOfferType: null,
            selectedOfferDescription1: null,
            selectedOfferDescription2: null,
            options1_1: '',
            options1_2: '',
            options1_3: '',
            options1_4: 'Freebie - ',
            options2_1: '',
            options2_2: '',
            frontImage: '',
            backImage: '',
            unitTypes: ['gram', 'kg', 'litre', 'ml', 'pieces'],
            measurementUnit: 'gram',
            productsFromTitle: [],
            showProducts: false,
            error: '',
            loading: false,
        };
    }

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        const tar = ['mrp', 'labelCode'];
        if (tar.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val,
        });
    };

    handleListinghasOffer = (e) => {
        let a = true;
        if (e.target.value === 'false') {
            a = false;
        }

        this.setState({ listingHasOffer: a }, () => {});
    };

    getOfferTitle = () => {
        const {
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            options1_1,
            options1_2,
            options1_3,
            options1_4,
            options2_1,
            options2_2,
            measurementUnit,
        } = this.state;
        let offerTitle = '',
            valueValidation = false;

        switch (selectedOfferType) {
            case 'Within Pack/Kitted':
                switch (selectedOfferDescription1) {
                    case 'Rs. Off (Rs.X OFF)':
                        valueValidation = Number(options1_1) > 0;
                        offerTitle = `Rs.${options1_1} Off`;
                        break;
                    case 'Extra Grammage % (X% Extra)':
                        valueValidation = Number(options1_2) > 0;
                        offerTitle = `${options1_2}% Extra`;
                        break;
                    case 'Extra Grammage (Xg FREE)':
                        valueValidation = Number(options1_3) > 0;
                        offerTitle = `${options1_3} ${measurementUnit} Free`;
                        break;
                    case 'Different product free inside (FREE X product worth Y Rs)':
                        valueValidation = options1_4 && options1_4.length > 0;
                        offerTitle = `${options1_4} Free Inside`;
                        break;
                    default:
                        console.log('Unknown case');
                }
                break;
            case 'Outside Pack/Unkitted':
                switch (selectedOfferDescription2) {
                    case 'Same Product Free (Buy X get Y FREE)':
                        valueValidation =
                            Number(options2_1) > 0 && Number(options2_2) > 0;
                        offerTitle = `Buy ${options2_1} Get ${options2_2} Free`;
                        break;
                    case 'Different Product Free':
                        valueValidation =
                            Number(options2_1) > 0 &&
                            Number(options2_2) > 0 &&
                            options1_4 &&
                            options1_4.length > 0;
                        offerTitle = `Buy ${options2_1} Get ${options2_2} ${options1_4} Free`;
                        break;
                    default:
                        console.log('Unknown case');
                }
                break;
            default:
                console.log('Unknown case');
        }

        if (valueValidation) {
            return offerTitle;
        } else {
            return '';
        }
    };

    parentFreebieUI = () => {
        const { options2_1, options2_2 } = this.state;
        return (
            <div>
                <div className='top-twenty justCent'>
                    <div style={{ width: '75%' }}>
                        <InputFloating
                            type='number'
                            label='Buy Parent Product'
                            name='options2_1'
                            value={options2_1}
                            onChange={(e) => {
                                this.setNameToValue(e);
                            }}
                        />
                    </div>
                    <div className='symbolBox' style={{ width: '25%' }}>
                        X Units
                    </div>
                </div>
                <div className='top-twenty justCent'>
                    <div style={{ width: '75%' }}>
                        <InputFloating
                            type='number'
                            label='Get Freebie'
                            name='options2_2'
                            value={options2_2}
                            onChange={(e) => {
                                this.setNameToValue(e);
                            }}
                        />
                    </div>
                    <div className='symbolBox' style={{ width: '25%' }}>
                        Y Units
                    </div>
                </div>
            </div>
        );
    };

    validateTitle = (title) => {
        if (
            title &&
            title.length > 10 &&
            title.substring(0, 10).toLowerCase() === 'freebie - '
        ) {
            return true;
        }

        return false;
    };

    searchProductFromTitle = (title) => {
        this.setState({ loading1: true, options1_4: title });
        InwardingApiHandlerTest.searchProductFromTitle(title)
            .then((data) => {
                this.setState({
                    productsFromTitle: data.productSearchResponseList,
                    showProducts: true,
                });
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading1: false });
            });
    };

    inputTitleChanged = (e, num) => {
        let title = e.target.value;

        //within pack, no title search
        if (num === 1) {
            this.setState({ options1_4: title });
            return;
        }

        //outside pack, display products according tot title and Freebie - should be prefix
        if (!this.validateTitle(title)) {
            title = 'Freebie - ';
        }

        this.searchProductFromTitle(title);
    };

    productSearchUI = (num) => {
        const { options1_4, productsFromTitle, loading1, showProducts } =
            this.state;

        return (
            <div className='top-twenty'>
                <InputFloating
                    type='text'
                    label='Free Product Name'
                    name='options1_4'
                    value={options1_4}
                    onChange={(e) => {
                        this.inputTitleChanged(e, num);
                    }}
                />

                {loading1 ? (
                    <div
                        className='product-search-dropdown'
                        style={{
                            display: 'block',
                            textAlign: 'center',
                            padding: '10px',
                            height: '50px',
                        }}
                    >
                        <CircularProgress
                            style={{ color: '#000' }}
                            size={23}
                            thickness={3}
                        />
                    </div>
                ) : (
                    <React.Fragment>
                        {productsFromTitle.length > 0 && showProducts ? (
                            <ul
                                className='product-search-dropdown'
                                style={{ display: 'block' }}
                            >
                                {productsFromTitle.map((product) => {
                                    return (
                                        <li
                                            className={'dropdown-data-rec'}
                                            key={product.jpin}
                                            onClick={() => {
                                                this.setState({
                                                    options1_4: product.title,
                                                    offerJpin: product.jpin,
                                                    selectedFreebie: product,
                                                    showProducts: false,
                                                });
                                            }}
                                        >
                                            <div className='dropdown-data-rec-inner'>
                                                <div className='row'>
                                                    <div
                                                        className='col-xs-3'
                                                        style={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                product.imageUrl
                                                            }
                                                            style={{
                                                                maxWidth:
                                                                    '100%',
                                                                maxHeight:
                                                                    '40px',
                                                            }}
                                                            alt='product'
                                                        />
                                                    </div>
                                                    <div className='col-xs-9'>
                                                        {product.title}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : null}
                    </React.Fragment>
                )}
            </div>
        );
    };

    isNewListingValidated2 = () => {
        const { listingHasOffer, newMrp, frontImage, backImage } = this.state;

        const offerTitle = this.getOfferTitle();

        // && frontImage && backImage
        if (
            Number(newMrp) > 0 &&
            (!listingHasOffer ||
                (listingHasOffer && offerTitle && frontImage && backImage))
        ) {
            return true;
        }

        return false;
    };

    setOfferType = (val) => {
        if (val === 'Within Pack/Kitted') {
            this.setState({
                selectedOfferType: val,
                options1_4: '',
                productsFromTitle: [],
            });
        } else {
            this.setState({ selectedOfferType: val, options1_4: 'Freebie - ' });
        }
    };

    createNewListing2 = () => {
        const {
            listingHasOffer,
            newMrp,
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            frontImage,
            backImage,
            offerJpin,
            measurementUnit,
        } = this.state;
        var mOffer = {};
        mOffer.offerJPIN = offerJpin ? offerJpin : null;
        let offerTypeDescription = '',
            mUnit = '';

        if (listingHasOffer) {
            mOffer = {
                ...mOffer,
                title: this.getOfferTitle(),
                offerType: selectedOfferType,
                frontImage: frontImage,
                backImage: backImage,
                description: null,
            };
            if (selectedOfferType === 'Outside Pack/Unkitted') {
                mOffer.offerType = 'HAS_SEPARATE_ITEMS';
                offerTypeDescription = selectedOfferDescription2;
            } else if (selectedOfferType === 'Within Pack/Kitted') {
                mOffer.offerType = 'WITHIN_PACK';
                offerTypeDescription = selectedOfferDescription1;
                if (selectedOfferDescription1 === 'Extra Grammage (Xg FREE)') {
                    mUnit = measurementUnit;
                }
            }
        }

        let req = {
            vendorInvoiceId: this.props.vinv,
            manufacturerOfferRequest: listingHasOffer ? mOffer : null,
            mrp: newMrp,
            jpin: this.props.jpin,
        };

        this.setState({ loading: true });
        InwardingApiHandlerTest.createNewListing(req)
            .then((resp) => {
                this.props.newListingCreated(resp);
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        const {
            newMrp,
            listingHasOffer,
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            options1_1,
            options1_2,
            options1_3,
            frontImage,
            backImage,
            unitTypes,
            measurementUnit,
            loading,
            error,
        } = this.state;

        const offerTitle = this.getOfferTitle();
        return (
            <React.Fragment>
                <div style={{ position: 'relative' }}>
                    <div style={{ margin: '10px' }}>
                        {/* <div style={{ backgroundColor: '#fff', border: '1px solid #dfdfdf', padding: '10px' }}>
                        <div className="row">
                            <div className="col-xs-4" style={{ textAlign: 'center' }}>
                                <img src={selectedProduct.productInfoResponse.imageUrls[0].thumbnail} style={{ maxWidth: '100%', maxHeight: '100px' }} alt="product" />
                            </div>
                            <div className="col-xs-8 no-left-padding">
                                <div className="v-imp-txt">{selectedProduct.productInfoResponse.title}</div>
                            </div>
                        </div>
                    </div> */}
                        {/* <div style={{ backgroundColor: '#fff', border: '1px solid #dfdfdf', padding: '10px', marginTop: '10px' }}> */}
                        <div
                            className='v-imp-txt'
                            style={{ fontWeight: 'bold' }}
                        >
                            Enter Listing Details
                        </div>

                        <div className='top-twenty input-group'>
                            <span className='input-group-addon'>₹</span>
                            <InputFloating
                                type='number'
                                label='MRP'
                                value={newMrp}
                                name='newMrp'
                                onChange={this.setNameToValue}
                            />
                        </div>

                        <div
                            className='top-ten'
                            style={{ border: '1px solid #dfdfdf' }}
                        ></div>

                        {/*<div className="top-ten v-imp-txt" style={{ fontWeight: 'bold' }}>Does this product have an offer/freebie?</div>*/}
                        {/*<div className="row" style={{ fontSize: '18px' }}>
                            <div className="col-xs-6">
                                <Radio checked={listingHasOffer} onChange={this.handleListinghasOffer} value="true" name="radio-button-demo" aria-label="A" color="default" classes={{ checked: 'blue' }} /> <span style={listingHasOffer ? { color: '#1394f6' } : {}}>Yes</span>
                            </div>
                            <div className="col-xs-6">
                                <Radio checked={!listingHasOffer} onChange={this.handleListinghasOffer} value="false" name="radio-button-demo" aria-label="A" color="default" /> No
                            </div>
                        </div>*/}

                        {listingHasOffer ? (
                            <div style={{ marginTop: '5px' }}>
                                <ExpDropSelector
                                    options={offerTypes}
                                    selected={selectedOfferType}
                                    classes={{ drop: 'invoice-type-drop' }}
                                    selctionChange={(val) => {
                                        this.setOfferType(val);
                                    }}
                                    type={'Offer Type'}
                                />
                                {selectedOfferType === 'Within Pack/Kitted' ? (
                                    <div className='top-twenty'>
                                        <ExpDropSelector
                                            options={offerDescriptions1}
                                            selected={selectedOfferDescription1}
                                            classes={{
                                                drop: 'invoice-type-drop',
                                            }}
                                            selctionChange={(val) => {
                                                this.setState({
                                                    selectedOfferDescription1:
                                                        val,
                                                });
                                            }}
                                            type={'Offer Description'}
                                        />
                                        {selectedOfferDescription1 ===
                                        'Rs. Off (Rs.X OFF)' ? (
                                            <div className='top-twenty justCent'>
                                                <div
                                                    className='symbolBox'
                                                    style={{ width: '15%' }}
                                                >
                                                    ₹
                                                </div>
                                                <div style={{ width: '85%' }}>
                                                    <InputFloating
                                                        type='number'
                                                        label='Value of Rs. Off'
                                                        name='options1_1'
                                                        value={options1_1}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Extra Grammage % (X% Extra)' ? (
                                            <div className='top-twenty justCent'>
                                                <div style={{ width: '85%' }}>
                                                    <InputFloating
                                                        type='number'
                                                        label='Extra Weight % value'
                                                        name='options1_2'
                                                        value={options1_2}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className='symbolBox'
                                                    style={{ width: '15%' }}
                                                >
                                                    %
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Extra Grammage (Xg FREE)' ? (
                                            <div
                                                className='top-twenty'
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <div style={{ width: '70%' }}>
                                                    <InputFloating
                                                        type='number'
                                                        label='Extra Weight value'
                                                        name='options1_3'
                                                        value={options1_3}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ width: '30%' }}>
                                                    <ExpDropSelector
                                                        options={unitTypes}
                                                        selected={
                                                            measurementUnit
                                                        }
                                                        classes={{
                                                            drop: 'invoice-type-drop',
                                                        }}
                                                        selctionChange={(
                                                            val
                                                        ) => {
                                                            this.setState({
                                                                measurementUnit:
                                                                    val,
                                                            });
                                                        }}
                                                        type={'Unit'}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Different product free inside (FREE X product worth Y Rs)' ? (
                                            <div className='top-twenty'>
                                                {this.productSearchUI(1)}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                                {selectedOfferType ===
                                'Outside Pack/Unkitted' ? (
                                    <div className='top-twenty'>
                                        <ExpDropSelector
                                            options={offerDescriptions2}
                                            selected={selectedOfferDescription2}
                                            classes={{
                                                drop: 'invoice-type-drop',
                                            }}
                                            selctionChange={(val) => {
                                                this.setState({
                                                    selectedOfferDescription2:
                                                        val,
                                                });
                                            }}
                                            type={'Offer Description'}
                                        />
                                        {selectedOfferDescription2 ===
                                        'Same Product Free (Buy X get Y FREE)' ? (
                                            <div className='top-twenty'>
                                                {this.parentFreebieUI()}
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription2 ===
                                        'Different Product Free' ? (
                                            <div className='top-twenty'>
                                                {this.parentFreebieUI()}
                                                {this.productSearchUI(2)}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                {offerTitle ? (
                                    <div className='top-ten'>
                                        <span style={{ fontWeight: '600' }}>
                                            Offer title preview:
                                        </span>{' '}
                                        "{offerTitle}"
                                    </div>
                                ) : null}

                                <div className='top-ten row'>
                                    <div className='col-xs-6'>
                                        <div className='image-up-not'>
                                            Upload Front Image
                                        </div>
                                        {frontImage ? (
                                            <div>
                                                <img
                                                    src={frontImage}
                                                    alt='Product front'
                                                    style={{ maxWidth: '100%' }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <ImageUploader
                                                    url='inwarding/upload'
                                                    type='frontImage'
                                                    handleUploadResponse={(
                                                        resp,
                                                        type
                                                    ) => {
                                                        this.setState({
                                                            [type]: resp,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className='col-xs-6'>
                                        <div className='image-up-not'>
                                            Upload Back Image
                                        </div>
                                        {backImage ? (
                                            <div>
                                                <img
                                                    src={backImage}
                                                    alt='Product front'
                                                    style={{ maxWidth: '100%' }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <ImageUploader
                                                    url='inwarding/upload'
                                                    type='backImage'
                                                    handleUploadResponse={(
                                                        resp,
                                                        type
                                                    ) => {
                                                        this.setState({
                                                            [type]: resp,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    <div
                        style={{
                            position: 'sticky',
                            bottom: '0px',
                            width: '100%',
                        }}
                    >
                        <button
                            className='btn btn-big-fin'
                            onClick={this.createNewListing2}
                            disabled={!this.isNewListingValidated2()}
                        >
                            Create New Listing
                        </button>
                    </div>
                </div>

                {loading ? <MobLoader /> : null}
                {error ? (
                    <ErrorBox
                        errorText={this.state.error}
                        closeError={this.closeError}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/CreateNewListing.js